enum PhotoInventoryType {
  Adesa = 'adesa',
  Core = 'core',
  CoreOutdoor = 'coreOutdoor',
  DealerMarketplace = 'dmp',
  DriveTime = 'drivetime',
  Manheim = 'manheim',
  PeerToPeer = 'p2p'
}

export default PhotoInventoryType;
